import { Typography } from 'antd';
import { EnvironmentOutlined, PartitionOutlined } from '@ant-design/icons';
import type { TemplateSummary } from '@/api/types';
import { CategoryBadge } from './categoryBadge';

const { Text, Paragraph } = Typography;

/** One gallery card. Whole card is the click target (opens the detail drawer). */
export function TemplateCard({ template, onOpen }: { template: TemplateSummary; onOpen: () => void }) {
  return (
    <button
      type="button"
      onClick={onOpen}
      className="ol-tpl-card"
      aria-label={`Template: ${template.name}`}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'flex-start' }}>
        <Text strong style={{ fontSize: 14, lineHeight: 1.3 }}>
          {template.name}
        </Text>
        <CategoryBadge category={template.category} />
      </div>

      {template.description && (
        <Paragraph
          type="secondary"
          style={{ fontSize: 12.5, margin: '8px 0 0', lineHeight: 1.5 }}
          ellipsis={{ rows: 3 }}
        >
          {template.description}
        </Paragraph>
      )}

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 12, alignItems: 'center' }}>
        {template.jurisdiction && (
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 11.5, color: 'var(--ol-text-secondary)' }}>
            <EnvironmentOutlined aria-hidden />
            {template.jurisdiction}
          </span>
        )}
        {typeof template.nodeCount === 'number' && (
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 11.5, color: 'var(--ol-text-secondary)' }}>
            <PartitionOutlined aria-hidden />
            {template.nodeCount} node{template.nodeCount === 1 ? '' : 's'}
          </span>
        )}
      </div>
    </button>
  );
}
